import styled, { x } from '@xstyled/styled-components';
import React from 'react';
import { t } from 'ttag';
import ClockIcon from '~/assets/icons/clock.svg';
import { select } from '~/lib/select';
import { TrainingState, useTrainingStore } from '../state';

const Clock = styled(ClockIcon)`
  width: 10px;
  margin-right: xs;
  /* Follow text color so dark mode / brand surfaces stay readable (CAT-1261). */
  fill: currentColor;
  color: inherit;

  path {
    fill: currentColor;
  }
`;

const selector = (s: TrainingState) => select(s, 'title', 'duration');

export const TrainingTitle = () => {
  const { title, duration } = useTrainingStore(selector);

  return (
    <x.div p="md" pt="xs">
      <x.h2 fontSize={{ _: 'lg', sm: 'md' }} m={0}>
        {title}
      </x.h2>
      <x.small
        fontSize={{ _: 'xs', sm: 'xxs' }}
        display="flex"
        alignItems="center"
        color="black"
      >
        {/* CAT-1289 / EL–E121: decorative — visible text already has the duration. */}
        <Clock aria-hidden="true" focusable="false" />
        {t`${duration} minutes`}
      </x.small>
    </x.div>
  );
};
